import ScreenImage from "../assets/images/og-image.jpg";

const LoadingScreen = () => {
  return (
    <div className="absolute flex-col top-0 left-0 z-50 w-screen h-screen flex justify-center items-center bg-white">
      <div>
        <img src={ScreenImage} alt="Loading..." className="w-96" />
      </div>
      <h1>
        <span className="text-3xl font-bold text-gray-800">Loading...</span>
      </h1>
    </div>
  );
};

export default LoadingScreen;
